import React, { useState } from 'react';
import FadeIn from './FadeIn';
import SafeIcon from '../common/SafeIcon';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';

const FaqItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="border-b border-slate-200 last:border-0">
      <button 
        onClick={() => setIsOpen(!isOpen)}
        className="w-full py-6 flex justify-between items-center text-left focus:outline-none"
      >
        <span className="font-semibold text-slate-900">{question}</span>
        <SafeIcon icon={isOpen ? FiChevronUp : FiChevronDown} className="text-slate-400" />
      </button>
      {isOpen && (
        <div className="pb-6 text-slate-600 leading-relaxed">
          {answer}
        </div>
      )}
    </div>
  );
};

export default function FAQ() {
  const faqs = [
    {
      q: "Is this for beginners?",
      a: "Absolutely. This course is designed specifically for people who feel overwhelmed by their finances. We start from zero and assume no prior budgeting knowledge."
    },
    {
      q: "Do I need special software?",
      a: "No. You can complete the entire 7-day reset using just a pen and paper. We keep things as simple and accessible as possible."
    },
    {
      q: "How fast do I get access?",
      a: "Instantly. As soon as your payment of $1.98 is complete, you will receive an email with a link to access all the videos immediately."
    },
    {
      q: "Is this financial advice?",
      a: "No, this is an educational course designed to help you organize your personal budget and build daily habits. We are not financial advisors, and this does not replace professional financial or legal counseling."
    }
  ];

  return (
    <section className="py-16 bg-slate-50 px-4 sm:px-6">
      <div className="max-w-2xl mx-auto">
        <FadeIn>
          <h2 className="text-3xl font-bold text-slate-900 mb-8 text-center">Common Questions</h2>
          <div className="bg-white rounded-2xl shadow-sm border border-slate-200 px-6">
            {faqs.map((faq, i) => (
              <FaqItem key={i} question={faq.q} answer={faq.a} />
            ))}
          </div>
        </FadeIn>
      </div>
    </section>
  );
}